// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"4ffe4716","166":"1878dd84","335":"e3620681","372":"9cd9ad63","380":"8e03aca1","754":"493ab4f2","777":"d354b4cb"}[chunkId] + ".chunk.js";
};